import React from 'react';
import PropTypes from 'prop-types';
import Reactable from 'reactable';
import * as shapes from '../../shapes';
import { mapTableColumns } from '../../helpers';

const Tr = Reactable.Tr;
const Td = Reactable.Td;

const Item = ({ canModifyProducts, item, baseUrl, router }) => {
  const onClick = () => canModifyProducts && router.push(`${baseUrl}/${item.id}/edit`);
  const columns = mapTableColumns(item);

  return (
    <Tr
      className="c-table-card__row c-table-card__row--clickable"
      onClick={onClick}
      key={item.id}
    >
      { columns.map(column => (
        <Td
          className="c-table-card__cell"
          column={column}
          key={column}
        >
          {item[column]}
        </Td>
      )) }
    </Tr>
  );
};
Item.propTypes = {
  canModifyProducts: PropTypes.bool.isRequired,
  item: shapes.brand.isRequired,
  baseUrl: shapes.url.isRequired,
  router: shapes.router.isRequired,
};

export default Item;
